(function() {
  const searchContainer = document.querySelector('[data-blog-search]');
  if (!searchContainer) return;

  const sectionId = searchContainer.dataset.blogSearch;
  const form = document.getElementById('BlogSearchForm-' + sectionId);
  const clearBtn = document.getElementById('BlogSearchClear-' + sectionId);
  const grid = document.querySelector('#BlogArticlesGrid .blog-articles');
  const gridContainer = document.getElementById('BlogArticlesGrid');
  const searchHeading = document.getElementById('BlogSearchHeading-' + sectionId);
  const searchHeadingText = document.getElementById('BlogSearchHeadingText-' + sectionId);
  const clearInlineBtn = document.getElementById('BlogSearchClearInline-' + sectionId);
  const articlesCount = document.getElementById('ArticlesCount');
  const pagination = gridContainer ? gridContainer.querySelector('blog-load-more, .pagination') : null;
  let originalContent = null;
  let originalPaginationDisplay = null;
  const originalArticlesCount = articlesCount ? articlesCount.textContent : '';

  if (!form || !grid) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    const query = form.querySelector('input[type="search"]').value.trim();
    if (!query) return;
    performSearch(query);
  });

  function clearSearch() {
    if (originalContent !== null) {
      grid.innerHTML = originalContent;
      originalContent = null;
      if (pagination) pagination.style.display = originalPaginationDisplay || '';
    }
    clearBtn.style.display = 'none';
    searchHeading.style.display = 'none';
    if (articlesCount) articlesCount.textContent = originalArticlesCount;
    form.querySelector('input[type="search"]').value = '';
    // Remove search params from URL
    const url = new URL(window.location);
    url.searchParams.delete('q');
    url.searchParams.delete('type');
    url.searchParams.delete('options[prefix]');
    window.history.pushState({}, '', url);
  }

  clearBtn.addEventListener('click', clearSearch);
  clearInlineBtn.addEventListener('click', clearSearch);

  function performSearch(query) {
    // Save original grid content on first search
    if (originalContent === null) {
      originalContent = grid.innerHTML;
      if (pagination) {
        originalPaginationDisplay = pagination.style.display;
      }
    }

    // Show loading state
    gridContainer.classList.add('loading');

    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const searchUrl = root + 'search?q=' + encodeURIComponent(query) + '&type=article&options%5Bprefix%5D=last&view=blog-search';

    fetch(searchUrl)
      .then(function(response) { return response.text(); })
      .then(function(html) {
        gridContainer.classList.remove('loading');
        // Close the filter panel if open
        var openDetails = document.querySelector('.mobile-facets__disclosure[open]');
        if (openDetails) {
          openDetails.removeAttribute('open');
          var wrapper = openDetails.closest('.mobile-facets__wrapper');
          if (wrapper) wrapper.classList.remove('menu-opening');
          document.body.classList.remove('overflow-hidden-mobile');
        }
        grid.innerHTML = html;
        clearBtn.style.display = '';
        searchHeadingText.textContent = 'Showing results for \u201C' + query + '\u201D';
        searchHeading.style.display = '';
        // Update articles count
        if (articlesCount) {
          var resultCount = grid.querySelectorAll('.blog-articles__article').length;
          articlesCount.textContent = resultCount + (resultCount === 1 ? ' article' : ' articles');
        }
        // Hide pagination during search
        if (pagination) pagination.style.display = 'none';

        // Update URL
        const url = new URL(window.location);
        url.searchParams.set('q', query);
        window.history.pushState({}, '', url);

        // Scroll to results
        gridContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function() {
        gridContainer.classList.remove('loading');
        form.submit();
      });
  }

  // If URL has a search query on load, run the search
  const urlParams = new URLSearchParams(window.location.search);
  const initialQuery = urlParams.get('q');
  if (initialQuery) {
    form.querySelector('input[type="search"]').value = initialQuery;
    performSearch(initialQuery);
  }
})();